import { NgFor, NgForOf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-legal-navbar',
  templateUrl: './legal-navbar.component.html',
  styleUrls: ['./legal-navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, NgForOf, NgFor],
  standalone: true,
})
export class LegalNavbarComponent {
  @Input() links: { link: string; title: string }[] = [
    { link: '/legal/competition-terms-conditions', title: 'Terms & Conditions'},
    { link: '/legal/privacy-and-cookie-policy', title: 'Privacy and Cookie Policy'},
    { link: '/legal/responsible-playing', title: 'Responsible Playing'}
  ];
}
